import React from "react";

export const Page10Tamil = () => {
  return (
    <div className="page-tamil-container">
      <h1>யாகசாலை :</h1>
      <p>
        யாகசாலை 36 தத்துவ சொரூபமாகவும் சிவபெருமானது அட்டமூர்த்த வடிவமாகவும், ஆறு
        அத்துவாக்களின் வடிவாகவும் கூறப்படும். யாக மண்டபம் சாந்தியதீதகலை.
      </p>
      <h1>கும்பாபிஷேகம் :</h1>
      <p>
        யாக சாலையில் அமைக்கப்படும் குண்டங்களில் அக்னி வளர்க்கப்படும். அவை
        நாற்கோணம், முக்கோணம், அர்த்தசாஸ்திரம் முதலிய வடிவங்களில் காணப்படும்.
        குண்டங்களைச் சுற்றிப் பசுந் தர்பைகளைப் பரப்பி ஆல், அரசு முதலிய
        சமித்துக்களை குண்டத்தில் இட்டு கடைந்தெடுக்கப்பட்ட சுத்தமான அக்னி கொண்டு
        அதற்குரிய மந்திரங்களைச் சொல்லி அதி தெய்வங்களை மனத்தில் தியானித்து
        சுருக்கு, சுருவம் என்னும் கருவிகளைக் கொண்டு நெய்சொரிந்து அவி
        வளர்க்கப்படும். மந்திரம், கிரியை, பாவனை என்ற மூன்றாலும் வழிபாடு நிகழும்.
        ஓமகுண்டத்தில் எழும் புகையும் வேதம், சிவகாமம், திருமுறை ஒலிகளும்
        அன்பர்களின் நல்லெண்ணங்களும் எங்கும் வியாபித்திருக்கின்ற இறைவனது
        அருட்சத்தியைத் தூண்டிக் கும்பத்தில் பிரகாசிக்கச் செய்யும். அப்போது
        கும்பம் முழுமையான தெய்வீக சக்தியோடு திகழும். இவ்வாறு யாகசாலையில்
        நடைபெறும் கிரியைகள் முற்றுப் பெற்றவுடன் அச்சக்தி ஆலயத்திலுள்ள
        மூர்த்திகளுக்கு தருப்பைக்கயிறு, பொன், வெள்ளிக் கம்பிகளால்
        சேர்ப்பிக்கப்படும். அதன்பின் கும்பத்திலுள்ள நீர் சிகரங்களுக்கும்,
        பிம்பங்களுக்கும் அபிஷேகம் செய்யப் பெறும். விமான கலசம் மூல மூர்த்தியின்
        சக்தியை உலகெங்கும் பரவச் செய்து நன்மைகளை உலகிற்கு உண்டு பண்ணும்.
      </p>
      <h1>வாழ்த்து :</h1>
      <p style={{ fontWeight: "bold" }}>
        வான்முகில் வழாது பெய்க மலிவளம் சுரக்க மன்னன் <br />
        கோன்முறை அரசு செய்க குறைவிலாது உயிர்கள் வாழ்க <br />
        நான்மறை அறங்கள் ஓங்க நற்றவம் வேள்வி மல்க <br />
        மேன்மை கொள் சைவநீதி விளங்குக உலகம் எல்லாம்
      </p>
      <h1>உங்களுடைய ராசி தெரிந்து கொள்ளுங்கள் :</h1>
      <p>
        தற்காலம் செய்திப் பத்திரிகைகள் தொலைக்காட்சி இவைகளில் ராசி பலன்
        சொல்லப்படுகிறது. மக்கள் தங்களுக்கான பலன் தெரிந்து கொள்ள அவைகளை விரும்பி
        படிக்கிறார்கள். பார்க்கிறார்கள், அவர்களில் சிலருக்கு பிறந்த நட்சத்திரம்
        மட்டும் தெரிகிறது. அவர்களுக்கு உரிய ராசி தெரிவதில்லை. அவர்களுக்கு
        பயன்படும் வகையில் இந்த ராசிக் கட்டம் இம்மலரில் இடம் பெற்றுள்ளது.
      </p>
    </div>
  );
};
